import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RestService } from '../../../service/rest.service';
import { Message } from '../../../service/message.service';
import { LoaderService } from '../../../service/loader.service';
import { SeoService } from '../../../service/seo.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-imprese-startup',
  templateUrl: './imprese-startup.component.html',
  styleUrl: './imprese-startup.component.scss',
  standalone: false
})
export class ImpreseStartupComponent implements OnInit {

  constructor(
    private router: Router,
    private loader: LoaderService,
    private location: Location,
    private rest: RestService,
    private message: Message,
    private seo: SeoService,
    private translocoService: TranslocoService
  ) {}

  currentType = 0;
  plans: any[] = [];

  ngOnInit(): void {
    this.seo.updateSeo({
      titleSeo: "Piani e Servizi di Consulenza Innovazione | Innovation Plaza",
      metadescription: 'Scopri i nostri piani di consulenza per innovazione, bandi e finanziamenti. Soluzioni su misura per imprese, startup e pubblica amministrazione.',
      url: 'https://innovationplaza.it/piani'
    });

    const params = new URLSearchParams(window.location.search);
    const paid = params.get("paid");

    if (paid == 'false') {
      this.message.showMessage('Pagamento annullato', 'error');
    }

    if (paid == 'true') {
      this.loader.on();

      this.rest.get('/user/me').subscribe({
        next: (value) => {
          localStorage.setItem('user', JSON.stringify(value));
          this.loader.off(true);
          this.router.navigate(['profilo']);
        },
        error: () => {
          this.loader.off(true);
          this.router.navigate(['profilo']);
        },
      });

      this.message.showMessage('Ti sei abbonato con successo', 'success');
    }

    this.getPlans();
  }

  goRegister() {
    this.router.navigate(['/registrazione']);
  }

    scrollTop(){
    let containerWeb = document.getElementById('container-web')
    if (containerWeb) {
      containerWeb.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  goContact(){
    this.router.navigate(['/contatti']);
    this.scrollTop()
  }

  goTo() {
     this.message.showMessage('Il piano arriverà in futuro','error')
    // window.location.replace('contatti');
  }

  getPlans() {
    this.loader.on()
    this.rest.get('/plan').subscribe({
      next: (value: any) => {

        this.plans = value.data.map((res: any) => {
          if (res.description) {
            res.descriptions = res.description.split('/');
          }
          return res;
        });

        // Card "Registrati Gratuitamente"
        if(!localStorage.getItem('token')){
        this.plans.unshift({
          name: 'Registrati Gratuitamente',
          netprice: '0',
          description: 'Registrati gratuitamente',
          descriptions: [
            'Monitoraggio e consultazione scheda sintetica bandi',
            'Newsletter di aggiornamento sui bandi in uscita e pubblicati'
          ],
          view: true,
          comingSoon: false
        });}
        this.loader.off()
      },
      error: (err) => {
        this.loader.off()
        console.error(err);
      }
    });
  }

  fakeGoTo(plan: any) {
    if(plan.name == "Registrati Gratuitamente")
      return this.goRegister();
    if(plan.contactUs)
      return this.goContact();
    let token = localStorage.getItem('token')
    let role = JSON.parse(localStorage.getItem('user') ?? '')?.role
    if (token) {
      if (role == 2 || role == 3 || role == 4) {
        this.loader.on()
        this.rest.post('/stripe/checkout/plan', { planId: plan.id }).subscribe({
          next: (value: any) => {
            this.loader.off(true)
            window.location.replace(value.url);
          },
        });
      } else {
        this.message.showMessage('Hai gia un piano attivo', 'error')
      }
    } else {
      this.message.showMessage('Devi essere loggato per acquistare un piano', 'error')
    }
  }
}